import { render } from "./GamePerformanceTable.vue?vue&type=template&id=ae93db86&scoped=true"
import script from "./GamePerformanceTable.vue?vue&type=script&lang=js"
export * from "./GamePerformanceTable.vue?vue&type=script&lang=js"

import "./GamePerformanceTable.vue?vue&type=style&index=0&id=ae93db86&scoped=true&lang=css"

import exportComponent from "C:\\Users\\JavonOnuigbo\\mgs\\RabbitsfootOperatorApps\\reportpanel\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae93db86"]])

export default __exports__